import { MenuEntry } from '@europrocurement/flexy-components';

import { PublisherMenuEntries } from '../pages/Fournisseurs/PublisherRouter';
import { FormalitiesMenuEntries } from '../pages/Formalities';
import { PrescripteurMenuEntries } from '../pages/Prescripteurs/PrescripteurRouter';
import { SignatureMenuEntries } from '../pages/Signature/SignatureRouter';
import { AchatsMenuEntries } from '../pages/Achats/AchatsRouter';
import { FormalityMenuEntries } from '../pages/Formalities/FormalityRouter';
import { UtilisateursMenuEntries } from '../pages/Utilisateurs/UtilisateursRouter';
import { TachesMenuEntries } from '../pages/Taches';

const menuEntries: MenuEntry[] = [
    {
        title: 'Dashboard',
        icon: 'house',
        href: '/accueil',
    },

    // Prescripteur
    ...PrescripteurMenuEntries,

    // Publisher
    ...PublisherMenuEntries,

    // Comptabilité
    ...AchatsMenuEntries,

    // Import signature menu entries
    ...SignatureMenuEntries,

    // Formalities -> Dossiers / invoices
    ...FormalitiesMenuEntries,

    {
        title: 'Mes sociétés',
        icon: 'building-user',
        role: 'realm:interne',
        href: 'societes/',
    },

    // Taches
    ...TachesMenuEntries,

    // Administration
    {
        title: 'Administration',
        icon: 'gear',
        role: 'realm:interne',
        children: [
            {
                title: 'Gestion des offres marketing',
                icon: 'tag',
                href: '/admin/offres',
                role: 'realm:interne',
            },
            ...FormalityMenuEntries,
            ...UtilisateursMenuEntries,
        ],
    },
];

export default menuEntries;
